import React from 'react';

type TextBoxProps = {
  className?: string;
  name: string;
  error?: boolean;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  validator?: any;
  [x: string]: any;
};

function TextBoxInput({ className, name, error, onChange, validator, ...props }: TextBoxProps) {
  return (
    <div className="relative">
      {validator}
      <textarea
        {...props}
        className={`${className || ''} ${
          error ? '!border-river-red focus:!ring-river-red' : ''
        } disabled:border-[#dfe5eb] disabled:bg-[#F9F9F9]`}
        name={name}
        onChange={onChange}
      />
    </div>
  );
}

export default TextBoxInput;
